import { render, staticRenderFns } from "./WorkflowHeader.vue?vue&type=template&id=1c828c40"
import script from "./WorkflowHeader.vue?vue&type=script&lang=js"
export * from "./WorkflowHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c828c40')) {
      api.createRecord('1c828c40', component.options)
    } else {
      api.reload('1c828c40', component.options)
    }
    module.hot.accept("./WorkflowHeader.vue?vue&type=template&id=1c828c40", function () {
      api.rerender('1c828c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowHeader.vue"
export default component.exports